import NextLink from "next/link";
import classNames from "classnames";

const Link = ({ children, className, noUnderline, ...other }) => {
  return (
    <NextLink
      className={classNames(className, noUnderline && "no-underline")}
      {...other}
    >
      {children}
    </NextLink>
  );
};

export default Link;
